import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from 'src/environments/environment'
import { formatErrorMessage } from "src/services/data/users.service";
import { ToasterService } from "../toaster/toaster.service";

export type EffectResult<OT> = ((...args: any[]) => Observable<OT>);

export function catchAndLog<T extends (a: { error: any }) => Action>(toaster: ToasterService, msg: string, action: T): EffectResult<Action> {
  return catchError(err => {
    console.error(msg, formatErrorMessage(err) || err)
    // WA-20508: Suppress error toasters for load/fetch operations when feature flag is enabled.
    // We check against `msg` here because the API error message may replace it before
    // reaching toaster.error(), where the regex would not match.
    if (environment.DISABLE_ERROR_TOASTERS_FOR_LOAD_DATA && /^(Unable to (load|fetch)|Failed (to load|loading))/i.test(msg)) return of(action({ error: err }))
    if (!err?.toasted) toaster.error(err.error?.error?.message || msg, formatErrorMessage(err) || err)
    return of(action({ error: err }))
  })
}
